// extracted by mini-css-extract-plugin
export default {"select_group":"SelectInput_select_group__WNqFF","form_label":"SelectInput_form_label__EEbuv"};